export default {
    name: 'darkgray',
    label: '黑灰 darkgray',
    styleDir: 'styles',
    imageDir: 'images',
    cssVars: {
        '--theme-tabbar-shell-bg': 'linear-gradient(180deg, #2d2926 0%, #171412 100%)',
        '--theme-tabbar-text': 'rgba(207, 199, 189, .78)',
        '--theme-tabbar-active-text': '#ffffff',
        '--theme-tabbar-divider': 'rgba(224, 190, 162, .2)',
        '--theme-tabbar-active-bg': 'linear-gradient(180deg, #4a4039 0%, #2d2723 100%)',
        '--theme-tabbar-active-bg-size': '100% 100%',
        '--theme-tabbar-active-bg-position': 'center'
    }
}
